import React from 'react';
import classNames from 'classnames';

import Checkbox from '../Checkbox/Checkbox';
import { FilterOption } from './FilterSelect';

import styles from './OptionsList.scss';

interface OptionsListProps {
  onChange: (checked: boolean, value: string) => void;
  options: FilterOption[];
  selectedValues: string[];
}

export function OptionsList(props: OptionsListProps): React.ReactElement {
  const { onChange, options, selectedValues } = props;

  return (
    <div className={styles.container}>
      {options.map(({ label, count, value }) => {
        const selectedValue = selectedValues.indexOf(value) >= 0 ? value : '';

        return (
          <div key={label} className={classNames(styles.input, { [styles.selected]: !!selectedValue })}>
            <Checkbox
              key={value}
              name={value}
              value={selectedValue}
              onChange={onChange}
              options={{ i18nOptions: { count } }}
            >
              {label}
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(OptionsList);
